<template>
  <el-dialog
    class="tax-basis"
    title=" "
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="40%"
    :before-close="colse"
  >
    <div class="content">
      <div class="title">计税依据</div>
      <div>
        本期应预扣预缴税额 =<span class="red"
          > (累计收入 - 累计费用 - 累计免税收入 - 累计减除费用 - 累计依法确定的其他扣除)</span
        >
        × 预扣率 - 速算扣除数 - 累计减免税额 - 累计已预扣预缴税额
      </div>

      <div>其中:</div>
      <div>1、累计收入：当年截至本月从平台取得的劳务报酬总收入</div>
      <div>2、累计费用：按累计收入 × 20%计算</div>
      <div>
        3、累计减除费用：5,000元/月 × 连续取得收入的月份数（中断后重新累计）
      </div>
      <div>
        4、适用税率及速算扣除数：括号内<span class="red">红字部分</span>金额在税率表的对应档位的值
      </div>
      <div>
        <div class="sub-title">个人所得税税率表</div>
        <div class="sub-desc">（综合所得税适用）</div>
        <el-image
          src="https://img.51xinlong.com/xladmin/home/taxDetailsImg.png"
        ></el-image>
      </div>
      <div class="notice">
        <div>
          依据:
          <span
            class="link"
            @click="
              gotoPage(
                'https://fgk.chinatax.gov.cn/zcfgk/c100012/c5241472/content.html'
              )
            "
            >《国家税务总局2025年第16号公告》==>点击查看</span
          >
        </div>
        <div
          class="link"
          @click="
            gotoPage(
              'https://fgk.chinatax.gov.cn/zcfgk/c100015/c5241475/content.html'
            )
          "
          style="text-indent: 2.5em;"
        >
          《国家税务总局关于互联网平台企业为平台内从业人员办理扣缴申报、代办申报若于事项的公告》的解读》==>点击查看
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "taxBasisDialog",
  props: {},
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    gotoPage(url) {
      const href = url;
      window.open(href, "_blank");
    },
    open() {
      this.dialogVisible = true;
    },
    colse() {
      this.dialogVisible = false;
    },
  },
};
</script>
<style scoped lang="scss">
.tax-basis {
  .content {
    line-height: 24px;
    font-size: 16px;
    color: #000000;
    .red {
      color: #ff403c;
    }
  }
  .sub-title {
    text-align: center;
    margin-top: 36px;
    font-weight: 500;
    font-size: 20px;
  }
  .sub-desc {
    text-align: center;
    margin-top: 8;
    color: #3670f7;
    margin-bottom: 16px;
  }
  .notice {
    margin-top: 30px;
  }
  .title {
    text-align: center;
    font-size: 28px;
    color: #3670f7;
    margin-bottom: 16px;
  }
  .link {
    cursor: pointer;
    text-decoration: underline;
    color: #3670f7;
    &:hover {
      opacity: 0.9;
    }
  }
}
</style>
